import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Button, H2, Image, Link, ProductPriceBlock } from '@codex/basics';

const StyledLink = styled(Link)`
  display: inline-block;
  font-size: 14px;
  margin-bottom: 11px;
`;

const NoUnderscoreUrl = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;

const StyledLi = styled.li`
  padding-left: 3px;
  margin-left: 15px;
`;

const StyledContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const ImageWrapper = styled.div`
  margin: 0 9% 8%;
  justify-content: center;
`;

const ListWrapper = styled.div`
  flex-grow: 2;
  width: 120px;
  min-width: 110px;
  margin-right: 12%;
`;

const Ul = styled.ul`
  padding: 0;
`;

const PriceWrapper = styled.div`
  flex-grow: 2;
  max-width: 320px;
  [class^="ProductPriceBlock__Block-"] {
    line-height: 25px;
    border-color: #d3d3d3;
    
    [class^="ProductPriceBlock__CurrentPrice-"] {
      display: inline-block;
      padding: 0 2px;
      font-size: 16px;
    }
    
    [class^="ProductPriceBlock__CurrentPrice-"]::after {
      content: " per month";
      color: #000;
    }
  }
  [class^="Button-"]:last-of-type {
    margin-top: 6px;
  }
`;

const ParagraphTop = styled.p`
  margin-bottom: 4px;
`;

const ParagraphBottom = styled.p`
  margin-bottom: 4px;
`;

const StyledBox = styled(Box)`
  a + ${ParagraphBottom} {
    margin-top: 12px;
  }
`;

const ContinueButton = styled(Button)`
  margin-top: 10px;
  display: block;
`;

class ResultAttachment extends PureComponent {
  render() {
    const data = this.props;
    const { product } = data;
    const image = product && product.image;
    const productTitle = product && product.title;
    const firstButton = product && product.firstButton;
    const secondButton = product && product.secondButton;
    const {
      title,
      bottomButton,
      paragraphTop,
      paragraphBottom
    } = data;
    const productButtons = firstButton && secondButton;

    return (
      <StyledBox>
        <H2>
          {title[0].toUpperCase() + title.substr(1, title.length)}
        </H2>
        {image && (
        <StyledContent>
          <ImageWrapper>
            <Image
              alt={image.alt}
              image={image.src}
              width={51.5}
              height={82.3}
            />
          </ImageWrapper>
          <ListWrapper>
            <StyledLink
              href={productTitle.url}
            >
              {productTitle.label}
            </StyledLink>
            {product.specifications.length > 0 && (
            <Ul>
              {product.specifications.map((bullet, count) =>
                <StyledLi key={count}>{bullet}</StyledLi>)}
            </Ul>
            )}
          </ListWrapper>
          <PriceWrapper>
            <ProductPriceBlock
              compact
              currentPrice={product.price.value}
            />
            <br />
            {productButtons && (
              <div>
                <NoUnderscoreUrl href={firstButton.url}>
                  <Button full>{firstButton.label}</Button>
                </NoUnderscoreUrl>
                <br />
                <NoUnderscoreUrl href={secondButton.url}>
                  <Button>{secondButton.label}</Button>
                </NoUnderscoreUrl>
              </div>
            )}
          </PriceWrapper>
        </StyledContent>
        )}
        {paragraphTop && paragraphTop.map((paragraph, count) =>
          <ParagraphTop key={count} dangerouslySetInnerHTML={{ __html: paragraph }} />)}
        {bottomButton && (
        <NoUnderscoreUrl href={bottomButton.url}>
          <ContinueButton full>
            {bottomButton.label}
          </ContinueButton>
        </NoUnderscoreUrl>
        )}
        {paragraphBottom && paragraphBottom.map((paragraph, count) =>
          <ParagraphBottom key={count} dangerouslySetInnerHTML={{ __html: paragraph }} />)}
      </StyledBox>
    );
  }
}

ResultAttachment.displayName = 'ResultAttachment';

// TODO: refactoring PropTypes when will have real data

const continueButtonShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
});

ResultAttachment.propTypes = {
  bottomButton: continueButtonShape,
  paragraphBottom: PropTypes.arrayOf(PropTypes.string.isRequired),
  paragraphTop: PropTypes.arrayOf(PropTypes.string.isRequired),
  product: PropTypes.shape({
    firstButton: continueButtonShape,
    secondButton: continueButtonShape,
    image: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    }).isRequired,
    price: PropTypes.shape({
      period: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    }).isRequired,
    specifications: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    title: continueButtonShape
  }),
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

ResultAttachment.defaultProps = {
  product: null,
  bottomButton: null,
  paragraphTop: null,
  paragraphBottom: null
};

export default ResultAttachment;
